import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const FilterPanel = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  isOpen, 
  onToggle 
}) => {
  const positionOptions = [
    { value: 'all', label: 'All Positions' },
    { value: 'goalkeeper', label: 'Goalkeeper' },
    { value: 'defender', label: 'Defender' },
    { value: 'midfielder', label: 'Midfielder' },
    { value: 'forward', label: 'Forward' }
  ];

  const leagueOptions = [
    { value: 'all', label: 'All Leagues' },
    { value: 'premier', label: 'Premier League Experience' },
    { value: 'championship', label: 'Championship Experience' },
    { value: 'african', label: 'African League' },
    { value: 'european', label: 'European League' }
  ];

  const nationalityOptions = [
    { value: 'all', label: 'All Nationalities' },
    { value: 'nigeria', label: 'Nigeria' },
    { value: 'ghana', label: 'Ghana' },
    { value: 'senegal', label: 'Senegal' },
    { value: 'ivory-coast', label: 'Ivory Coast' },
    { value: 'cameroon', label: 'Cameroon' },
    { value: 'south-africa', label: 'South Africa' },
    { value: 'egypt', label: 'Egypt' },
    { value: 'morocco', label: 'Morocco' }
  ];

  const handleInputChange = (field, value) => {
    onFilterChange({ ...filters, [field]: value });
  };

  return (
    <div className={`bg-card border border-border rounded-lg transition-all duration-300 ${isOpen ? 'p-4 md:p-6' : 'p-4'}`}>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} color="var(--color-primary)" />
          <h3 className="text-base md:text-lg font-semibold text-foreground font-headline">Advanced Filters</h3>
        </div>
        <button
          onClick={onToggle}
          className="lg:hidden p-2 hover:bg-muted rounded-md transition-colors"
          aria-label="Toggle filters"
        >
          <Icon name={isOpen ? 'ChevronUp' : 'ChevronDown'} size={20} />
        </button>
      </div>
      <div className={`space-y-4 ${isOpen ? 'block' : 'hidden lg:block'}`}>
        <Input
          type="search"
          placeholder="Search by name..."
          value={filters?.search}
          onChange={(e) => handleInputChange('search', e?.target?.value)}
          className="w-full"
        />

        <Select
          label="Position"
          options={positionOptions}
          value={filters?.position}
          onChange={(value) => handleInputChange('position', value)}
        />

        <Select
          label="League Experience"
          options={leagueOptions}
          value={filters?.league}
          onChange={(value) => handleInputChange('league', value)}
        />

        <Select
          label="Nationality"
          options={nationalityOptions}
          value={filters?.nationality}
          onChange={(value) => handleInputChange('nationality', value)}
          searchable
        />

        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">Age Range</label>
          <div className="grid grid-cols-2 gap-2">
            <Input
              type="number"
              placeholder="Min"
              value={filters?.ageMin}
              onChange={(e) => handleInputChange('ageMin', e?.target?.value)}
              min="16"
              max="40"
            />
            <Input
              type="number"
              placeholder="Max"
              value={filters?.ageMax}
              onChange={(e) => handleInputChange('ageMax', e?.target?.value)}
              min="16"
              max="40"
            />
          </div>
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">Transfer Value (€M)</label>
          <div className="grid grid-cols-2 gap-2">
            <Input
              type="number"
              placeholder="Min"
              value={filters?.valueMin}
              onChange={(e) => handleInputChange('valueMin', e?.target?.value)}
              min="0"
            />
            <Input
              type="number"
              placeholder="Max"
              value={filters?.valueMax}
              onChange={(e) => handleInputChange('valueMax', e?.target?.value)}
              min="0"
            />
          </div>
        </div>

        <div className="space-y-3 pt-2">
          <label className="text-sm font-medium text-foreground">Availability</label>
          <Checkbox
            label="Available for immediate transfer"
            checked={filters?.immediateTransfer}
            onChange={(e) => handleInputChange('immediateTransfer', e?.target?.checked)}
          />
          <Checkbox
            label="FIFA verified profiles only"
            checked={filters?.fifaVerified}
            onChange={(e) => handleInputChange('fifaVerified', e?.target?.checked)}
          />
          <Checkbox
            label="Video highlights available"
            checked={filters?.hasVideo}
            onChange={(e) => handleInputChange('hasVideo', e?.target?.checked)}
          />
        </div>

        <div className="flex gap-2 pt-4">
          <Button
            variant="outline"
            fullWidth
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
          >
            Clear All
          </Button>
          <Button
            variant="default"
            fullWidth
            iconName="Search"
            iconPosition="left"
          >
            Apply
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;